/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'sarsaparilla';
import * as tripPlannerActions from '../actions/tripPlanner';
import TripDestinationSearchInput from './TripDestinationSearchInput';

const propTypes = {
    title: PropTypes.string,
    dispatch: PropTypes.func,
    tripPlanner: PropTypes.object,
};

const defaultProps = {
    title: '',
};

export class TripResultsViewSwitch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.onLocationSearchChange = this.onLocationSearchChange.bind(this);
    }

    changeView(view, event) {
        event.preventDefault();

        this.props.dispatch(tripPlannerActions.setView(view));
    }

    onLocationSearchChange(searchLocation) {
        this.props.dispatch(tripPlannerActions.setView('map'));
        this.props.dispatch(tripPlannerActions.setSearchLocation(null));
        setTimeout(() => {
            this.props.dispatch(tripPlannerActions.setSearchLocation(searchLocation));
        }, 200);
    }

    render() {
        const mapSelected = this.props.tripPlanner.view === 'map';
        const mapTabClass = mapSelected ? 'rec-tab-active' : '';
        const listTabClass = mapSelected ? '' : 'rec-tab-active';

        return (
            <div className="trip-planner-view-switch">
                <div className="rec-tab-list" role="tablist">
                    <span>View:</span>
                    <ul className="rec-tabs" role="tablist">
                        <li className={`rec-tab ${mapTabClass}`} role="presentation">
                            <button
                                type="button"
                                onClick={this.changeView.bind(this, 'map')}
                                className="rec-button-link"
                                role="tab"
                                aria-selected={mapSelected}
                            >
                                Map
                            </button>
                        </li>
                        <li className={`rec-tab ${listTabClass}`} role="presentation">
                            <button
                                type="button"
                                onClick={this.changeView.bind(this, 'list')}
                                className="rec-button-link"
                                role="tab"
                                aria-selected={!mapSelected}
                            >
                                List
                            </button>
                        </li>
                    </ul>
                </div>
                <TripDestinationSearchInput
                    placeholder={'Find a Location'}
                    showAddresses={false}
                    searchInputIcon={<Icon iconName="search" />}
                    onChange={this.onLocationSearchChange}
                />
            </div>
        );
    }
}

TripResultsViewSwitch.propTypes = propTypes;
TripResultsViewSwitch.defaultProps = defaultProps;

function select(state) {
    return {
        tripPlanner: state.tripPlanner,
    };
}

export default connect(select)(TripResultsViewSwitch);
